import React from 'react';
import { Create, List, Datagrid, TextField,  BooleanInput, Edit,SimpleForm,DisabledInput, BooleanField  } from 'react-admin';
import { DateInput,  Filter, TextInput, SelectInput, ReferenceInput, ReferenceField, FileField, FileInput,DateField } from 'react-admin';
import LinkToDocument from './components/LinkToDocument.js';

import { FormDataConsumer} from 'react-admin';
//import { EditButton } from 'react-admin';

import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';
//DateInput, 
import EditIcon from '@material-ui/icons/Edit';
import ThumbUpIcon from '@material-ui/icons/ThumbsUpDown';
import Tooltip from '@material-ui/core/Tooltip';

const styles = {
    flex: { display: 'flex'  },
};

/*
 <ReferenceInput source="type" reference="document_types"  label="Document type"   >
           <SelectInput optionText="description" />
        </ReferenceInput>
        */

export const DocumentFilter = props => (
    <Filter {...props}>
        <ReferenceInput source="folder" reference="folders"   >
            <SelectInput source="FullName"   />
        </ReferenceInput>
        <ReferenceInput source="client" reference="clients"   >
            <SelectInput source="name"   />
        </ReferenceInput>
       
        <DateInput source="created_at_start" label="Start"   alwaysOn   />
        <DateInput source="created_at_end" label="End"  alwaysOn />
        <TextInput source="description_like" label="Description" alwaysOn    />
        <SelectInput source="status" choices={[
                    { id: 'new', name: 'New' },
                    { id: 'approved', name: 'Approved' },
                    { id: 'rejected', name: 'Rejected' },
        ]}  />
    </Filter>
);

///
/*<ReferenceField source="type" reference="document_types" label="Document type" linkType={false}>
                <TextField source="description" />
            </ReferenceField>


            <ReferenceField source="client" reference="clients" linkType={false} >
                <TextField source="name" />
            </ReferenceField>
            */

 
export const DocumentList = props => (
    <List {...props}  filters={<DocumentFilter />}     ActionButtons={false} BulkActionButtons={false} >
        <Datagrid >
            <EditApprovedButton />
            <TextField source="id" />
            <TextField source="ClientName" label="Client" />
           
            <TextField source="description" />
            <ReferenceField source="folder" reference="folders2" linkType={false} >
                <TextField source="FullName" />
            </ReferenceField>
            <DateField source="created_at" />
            <LinkToDocument label="Download"/>
            <BooleanField source="active" />
            <TextField source="status"   />
            <DateField source="expirationdate" label="Expiration" />
        </Datagrid>
    </List>
);

const EditDocumentButton = ({ record }) => 
     record && record.active && record.status === "new" ? (<Tooltip title="Edit document"><Button component={Link} to={{pathname: '/documents/' + record.id , }} > <EditIcon /> </Button></Tooltip>) : null;
///
const EditApprovedButton = ({ record }) => 
     record && record.active && record.status === "new" ? (<Tooltip title="Review document"><Button component={Link} to={{pathname: '/documents/' + record.id , }} > <ThumbUpIcon /> </Button></Tooltip>) : null;
///
/*<ReferenceField source="type" reference="document_types" label="Document type" linkType={false}>
                <TextField source="description" />
            </ReferenceField>
            */

export const DocumentListClients = props => (
    <List {...props} filters={<DocumentFilter />}
                      
                     filter={{ client:   [JSON.parse(localStorage.getItem("user")).client]  }} ActionButtons={false} BulkActionButtons={false}>
        <Datagrid >
            <EditDocumentButton />
            <TextField source="id" />
            
            <TextField source="description" />
            <ReferenceField source="folder" reference="folders" linkType={false} >
                <TextField source="FullName" />
            </ReferenceField>
            <DateField source="created_at" />
            <LinkToDocument label="Download"/>
            <BooleanField source="active" />
            <TextField source="status"   />
            <DateField source="expirationdate" label="Expiration" />
        </Datagrid>
    </List>
);



// in src/Documents.js
/*
<ReferenceInput source="type" reference="document_types"  label="Document type" fullWidth>
               <SelectInput optionText="description" />
            </ReferenceInput>
            */
export const DocumentEdit = props => (
    <Edit title={<DocumentTitle />} {...props}>
        <SimpleForm validate={validateDocumentCreation} redirect="list"  >
            <div  style={styles.flex} fullWidth >
               <DisabledInput source="id" />
               <DisabledInput source="client" fullWidth  />
               <DisabledInput source="FullName" fullWidth  />
               <DisabledInput source="user"  label='Created by' fullWidth />
               <DisabledInput source="status" />
            </div>
           <TextInput source="description" fullWidth />
           
            <FileInput source="document" label="Related files" multiple={false} >
                <FileField source="src" title="title" />
            </FileInput>
            <BooleanInput source="active"   />
        </SimpleForm>
    </Edit>
);


/* <ReferenceInput source="type" reference="document_types"  label="Document type" fullWidth>
               <SelectInput optionText="description" />
            </ReferenceInput>
            */
export const DocumentEditAdmin = props => (
    <Edit title={<DocumentTitle />} {...props}>
        <SimpleForm validate={validateDocumentCreation} redirect="list"  >
            <div  style={styles.flex} fullWidth >
               <DisabledInput source="id" />
               <DisabledInput source="client" fullWidth  />
               <DisabledInput source="FullName" fullWidth  />
               <DisabledInput source="user"  label='Created by1' fullWidth />
            </div>
           <TextInput source="description" fullWidth />
          
            <BooleanInput source="active"   />
            <div  style={styles.flex} fullWidth >
                <SelectInput source="status" choices={[
                    { id: 'approved', name: 'Approved' },
                    { id: 'rejected', name: 'Rejected' },
                ]} fullWidth />
             <FormDataConsumer>
                 {({ formData, ...rest }) => formData.status === "approved" &&
                      <DateInput   source="expirationdate" label="Expiration date" fullWidth  /> 
                 }
             </FormDataConsumer>
            </div>    
        </SimpleForm>
    </Edit>
);

///
const redirect = (basePath, id, data) => `/folders/list`;

/*<ReferenceInput source="type" reference="document_types"  label="Document type" fullWidth>
               <SelectInput optionText="description" />
            </ReferenceInput>
            */

export const DocumentCreate = props => (
    <Create {...props}>
        <SimpleForm validate={validateDocumentCreation} redirect={redirect}  >
           <div  style={styles.flex} fullWidth >
               <DisabledInput source="id" fullWidth />
               <DisabledInput source="client" defaultValue={JSON.parse(localStorage.getItem("user")).client} fullWidth />
               <DisabledInput source="folder" fullWidth  />
               <DisabledInput source="user" defaultValue={JSON.parse(localStorage.getItem("user")).id} fullWidth label='Created by'  />
               <DisabledInput source="status" defaultValue={"new"} />
           </div>
           
           <TextInput source="description" fullWidth/>
           <FileInput source="document" label="Related files" multiple={false} >
                <FileField source="src" title="title" />
            </FileInput>
            
            <BooleanInput source="active" defaultValue={true} />
        </SimpleForm>
    </Create>
);
////
const validateDocumentCreation = (values) => {
    const errors = {};
 /*   if (!values.client) {
        errors.client = ['The client is required'];
    }*/
  /*  if (!values.document_types) {
        errors.document_types = ['The document type is required'];
    }*/
    if (!values.description) {
        errors.description = ['The description is required'];
    }
    if (!values.document) {
        errors.document = ['The document is required'];
    }
    if (!values.expirationdate) {
        errors.expirationdate = ['The expiration date is required'];
    }
    return errors
};



export const DocumentCreateAdmin = props => (
    <Create {...props}>
        <SimpleForm validate={validateDocumentCreationAdmin} redirect={redirect}  >
           <div  style={styles.flex} fullWidth >
               <DisabledInput source="id" fullWidth />
               <DisabledInput source="folder" fullWidth  />
               <DisabledInput source="user" defaultValue={JSON.parse(localStorage.getItem("user")).id} fullWidth label='Created by'  />
               <DisabledInput source="status" defaultValue={"new"} />
           </div>
           
           <TextInput source="description" fullWidth/>
           <FileInput source="document" label="Related files" multiple={false} >
                <FileField source="src" title="title" />
            </FileInput>
            
            <BooleanInput source="active" defaultValue={true} />
        </SimpleForm>
    </Create>
);
////
const validateDocumentCreationAdmin = (values) => {
    const errors = {};
   
  /*  if (!values.document_types) {
        errors.document_types = ['The document type is required'];
    }*/
    if (!values.description) {
        errors.description = ['The description is required'];
    }
    if (!values.document) {
        errors.document = ['The document is required'];
    }
    if (!values.expirationdate) {
        errors.expirationdate = ['The expiration date is required'];
    }
    return errors
};

const DocumentTitle = ({ record }) => {
    return <span>Document: {record ? `"${record.description}"` : ''}</span>;
};
